import {
  FETCH_ERROR,
  FETCH_FEEDBACK_START,
  FETCH_FEEDBACK_SUCCESS,
  FEEDBACK_DATA,
  SET_FEEDBACK_API_PARAMS_OBJ,
  SET_FEEDBACK_SORT,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  error: "",
  feedbackLoading: false,
  apiParamsObj: {},
  feedbackCount: 0,
  feedbackData: [],
  sorterInput: "",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_FEEDBACK_START: {
      return {
        ...state,
        error: "",
        feedbackLoading: true,
      };
    }
    case FETCH_FEEDBACK_SUCCESS: {
      return {
        ...state,
        error: "",
        feedbackLoading: false,
      };
    }
    case FETCH_ERROR: {
      return {
        ...state,
        error: action.payload,
        feedbackLoading: false,
      };
    }
    case SET_FEEDBACK_API_PARAMS_OBJ: {
      return {
        ...state,
        apiParamsObj: action.payload,
      };
    }
    case SET_FEEDBACK_SORT: {
      return {
        ...state,
        sorterInput: { ...action.payload },
      };
    }
    case FEEDBACK_DATA: {
      return {
        ...state,
        error: "",
        feedbackCount: action.payload.count,
        feedbackData: action.payload.data,
        feedbackLoading: false,
      };
    }
    default:
      return state;
  }
};
